// const dev = 'http://localhost:8082'
// // const dev = 'https://nlsn-support-finance.nielseniq.com/op-test/api/index.php'
// const downDev = 'https://api-op-download-dot-nlsn-support-finance-wt-dev.uc.r.appspot.com'
// // const downDev = 'https://nlsn-support-finance.nielseniq.com/op-test/download/index.php'

// // for pharos
// // const prod = '/api/pharos/op/index.php'
// // for prod
// // const prod = '/op/api/index.php'
// // const downProd = '/op/download/index.php'
// // for dev
// const prod = '/op-test/api/index.php'
// const downProd = '/op-test/download/index.php'
// // const downProd = 'https://api-op-download-dot-nlsn-support-finance-wt-dev.uc.r.appspot.com'


export const url = process.env.VUE_APP_BACKEND_INDEX
export const down = process.env.VUE_APP_BACKEND_DOWNLOAD_INDEX
export const massUploadUrl = process.env.VUE_APP_BACKEND_MASS_UPLOAD_INDEX
